import React, { useState } from 'react';
import EditEducationModal from './EditEducationModal';

const ClientEducation = ({ client, submissions, onRefresh }) => {
    const [editingSubmissionId, setEditingSubmissionId] = useState(null);
    const [editingEducation, setEditingEducation] = useState(null);

    const fromSubmissions = submissions
        .map(sub => ({ data: sub.education_info, submissionId: sub.id }))
        .filter(item => item.data && Object.keys(item.data).length > 0);

    const fromClient = Array.isArray(client?.education_data) ? client.education_data.map(data => ({ data, submissionId: null })) : [];

    const educationData = [...fromClient, ...fromSubmissions];

    if (educationData.length === 0) {
        return (
            <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg overflow-hidden">
                <div className="bg-gray-900/50 p-4 border-b border-gray-700">
                    <h3 className="text-lg font-bold text-white uppercase tracking-wider">🎓 Education Information</h3>
                </div>
                <div className="p-8 text-center text-gray-400">
                    No education information available from wizard submissions.
                </div>
            </div>
        );
    }

    return (
        <>
            {editingSubmissionId && editingEducation && (
                <EditEducationModal
                    submissionId={editingSubmissionId}
                    educationData={editingEducation}
                    onClose={() => {
                        setEditingSubmissionId(null);
                        setEditingEducation(null);
                    }}
                    onSave={onRefresh}
                />
            )}

            <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg overflow-hidden">
                <div className="bg-gray-900/50 p-4 border-b border-gray-700">
                    <h3 className="text-lg font-bold text-white uppercase tracking-wider">🎓 Education Information</h3>
                </div>
                <div className="p-6 space-y-6">
                    {educationData.map((item, index) => (
                        <div key={index} className="p-4 bg-gray-700/50 rounded border border-gray-600 relative">
                            {item.submissionId && (
                                <button
                                    onClick={() => {
                                        setEditingSubmissionId(item.submissionId);
                                        setEditingEducation(item.data);
                                    }}
                                    className="absolute top-4 right-4 text-xs px-3 py-1.5 rounded bg-blue-600 text-white border border-blue-500 hover:bg-blue-700"
                                >
                                    ✏️ Edit
                                </button>
                            )}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {item.data.highestEducation && (
                                    <div>
                                        <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Highest Education</div>
                                        <div className="text-white font-mono">{item.data.highestEducation}</div>
                                    </div>
                                )}
                                {item.data.fieldOfStudy && (
                                    <div>
                                        <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Field of Study</div>
                                        <div className="text-white font-mono">{item.data.fieldOfStudy}</div>
                                    </div>
                                )}
                                {item.data.institution && (
                                    <div>
                                        <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Institution</div>
                                        <div className="text-white font-mono">{item.data.institution}</div>
                                    </div>
                                )}
                                {item.data.graduationYear && (
                                    <div>
                                        <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Graduation Year</div>
                                        <div className="text-white font-mono">{item.data.graduationYear}</div>
                                    </div>
                                )}
                                {item.data.gpa && (
                                    <div>
                                        <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">GPA</div>
                                        <div className="text-white font-mono">{item.data.gpa}</div>
                                    </div>
                                )}
                                {item.data.country && (
                                    <div>
                                        <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Country</div>
                                        <div className="text-white font-mono">{item.data.country}</div>
                                    </div>
                                )}
                            </div>

                            {/* Display all other fields as JSON */}
                            {Object.keys(item.data).length > 6 && (
                                <details className="mt-4">
                                    <summary className="text-xs text-blue-400 cursor-pointer hover:text-blue-300">View All Fields</summary>
                                    <pre className="mt-2 p-3 bg-gray-900 rounded text-xs text-gray-300 overflow-auto">
                                        {JSON.stringify(item.data, null, 2)}
                                    </pre>
                                </details>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default ClientEducation;
